import { fetchActiveTrials } from 'pricing-pages-lib/api/fetchActiveTrials';
import { ACTIVE_TRIALS } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchActiveTrialsRequestTypes = createRequestTypes(ACTIVE_TRIALS);
export const FetchActiveTrialsActions = createRequestActions(FetchActiveTrialsRequestTypes);
export const getActiveTrials = () => makeFetchRequest({
  requestActions: FetchActiveTrialsActions,
  fetch: fetchActiveTrials
});